var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.display
    ? _c(
        "div",
        { staticClass: "relative flex-level flex-top flex" },
        [
          !_vm.editMode
            ? _c(
                "div",
                {
                  staticClass:
                    "flex default-bkg br annotation-card-reply__container prelative"
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex flex-row ai-center jc-space" },
                    [
                      _c("person-list-light", {
                        staticClass: "wp-10",
                        attrs: {
                          list: [_vm.formatOwner],
                          "placeholder-singular": "Collaborateur",
                          "placeholder-plural": "Collaborateurs"
                        },
                        on: {
                          click: function($event) {
                            return _vm.goToUrl("/staff/" + _vm.reply.owner.id)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "flex-item-right flex flex-row ai-center"
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "gray-60 nowrap mr-2 annotation-card-reply__date"
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm._f("dateFormatter")(
                                      _vm.reply.timestamp,
                                      "NORMAL_DATE_TIME",
                                      true
                                    )
                                  ) +
                                  "\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.reply.can_edit || _vm.reply.can_delete
                            ? _c(
                                "el-dropdown",
                                [
                                  _c("CompassIconButton", {
                                    attrs: { icon: "action", size: "small" }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "el-dropdown-menu",
                                    {
                                      attrs: { slot: "dropdown" },
                                      slot: "dropdown"
                                    },
                                    [
                                      _vm.reply.can_edit
                                        ? _c(
                                            "el-dropdown-item",
                                            {
                                              attrs: { disabled: _vm.editMode },
                                              nativeOn: {
                                                click: function($event) {
                                                  return _vm.toggleEditMode()
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$l10n.__("Modifier"))
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.reply.can_delete
                                        ? _c(
                                            "el-dropdown-item",
                                            {
                                              nativeOn: {
                                                click: function($event) {
                                                  _vm.deleteModal = true
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$l10n.__("Supprimer")
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "content rich-text-style" },
                    [
                      _c("div", {
                        ref: "annotContent" + _vm.reply.id,
                        staticClass:
                          "editor-preview typographies-paragraph-medium-regular rich-text-style annotation-card-reply__content",
                        class: _vm.contentClass
                      }),
                      _vm._v(" "),
                      _vm.reply.content.length > 256
                        ? _c("CompassButton", {
                            staticClass: "annotation-card__button-read",
                            attrs: {
                              label: _vm.fullText
                                ? _vm.labelsButton.readLess
                                : _vm.labelsButton.readMore,
                              type: "secondary",
                              size: "small"
                            },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                _vm.fullText = !_vm.fullText
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            : _c("div", { staticClass: "wp-10 flex-column" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "flex default-bkg br annotation-card-reply__container prelative"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flex flex-row ai-center jc-space" },
                      [
                        _c("person-list-light", {
                          staticClass: "wp-10",
                          attrs: {
                            list: [_vm.formatOwner],
                            "placeholder-singular": "Collaborateur",
                            "placeholder-plural": "Collaborateurs"
                          },
                          on: {
                            click: function($event) {
                              return _vm.goToUrl("/staff/" + _vm.reply.owner.id)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm.reply.can_edit || _vm.reply.can_delete
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "flex-item-right flex flex-row ai-center"
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "gray-60 nowrap mr-2" },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm._f("dateFormatter")(
                                            _vm.reply.timestamp,
                                            "NORMAL_DATE_TIME",
                                            true
                                          )
                                        ) +
                                        "\n                    "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-dropdown",
                                  [
                                    _c("CompassIconButton", {
                                      attrs: { icon: "action", size: "small" }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "el-dropdown-menu",
                                      {
                                        attrs: { slot: "dropdown" },
                                        slot: "dropdown"
                                      },
                                      [
                                        _vm.reply.can_edit
                                          ? _c(
                                              "el-dropdown-item",
                                              {
                                                attrs: {
                                                  disabled: _vm.editMode
                                                },
                                                nativeOn: {
                                                  click: function($event) {
                                                    return _vm.toggleEditMode()
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$l10n.__("Modifier")
                                                  )
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.reply.can_delete
                                          ? _c(
                                              "el-dropdown-item",
                                              {
                                                nativeOn: {
                                                  click: function($event) {
                                                    _vm.deleteModal = true
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$l10n.__("Supprimer")
                                                  )
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("RichText", {
                      staticClass: "annotation-reply-richtext",
                      attrs: {
                        placeholder: _vm.$t.__("common.actions.answer_message"),
                        options: _vm.optionsRichText,
                        typeRichText: "comment",
                        showAIComponents: ""
                      },
                      scopedSlots: _vm._u(
                        [
                          _vm.replyIsUpdated
                            ? {
                                key: "actions",
                                fn: function() {
                                  return [
                                    _c("CompassButton", {
                                      attrs: {
                                        label: _vm.$t.__(
                                          "common.actions.cancel"
                                        ),
                                        type: "secondary",
                                        size: "small"
                                      },
                                      on: { click: _vm.toggleEditMode }
                                    }),
                                    _vm._v(" "),
                                    _c("CompassButton", {
                                      attrs: {
                                        label: _vm.$t.__("common.actions.save"),
                                        type: "primary",
                                        size: "small",
                                        loading: _vm.confirmLoading
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.submitUpdate(_vm.reply.id)
                                        }
                                      }
                                    })
                                  ]
                                },
                                proxy: true
                              }
                            : null
                        ],
                        null,
                        true
                      ),
                      model: {
                        value: _vm.updatedReply,
                        callback: function($$v) {
                          _vm.updatedReply = $$v
                        },
                        expression: "updatedReply"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "flex flex-row jc-space" }, [
                  _c("div", [
                    _vm.mentionAddedInEditing
                      ? _c("div", { staticClass: "fs-2 gray-80" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$l10n.__(
                                  "Les notifications ne sont pas envoyées lors d'une édition de commentaire"
                                )
                              ) +
                              "\n                "
                          )
                        ])
                      : _vm._e()
                  ])
                ])
              ]),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.deleteModal,
                width: "420",
                title: _vm.$t.__("common.actions.delete_message")
              },
              on: {
                "update:visible": function($event) {
                  _vm.deleteModal = $event
                }
              }
            },
            [
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.$l10n.__(
                      "Confirmez-vous vouloir faire disparaître votre commentaire ?"
                    )
                  )
                )
              ]),
              _vm._v(" "),
              _c("ul", [
                _c("li", [
                  _vm._v(
                    "- " +
                      _vm._s(
                        _vm.$l10n.__(
                          "Il n’apparaitra plus pour aucun de vos collaborateurs."
                        )
                      )
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "- " +
                      _vm._s(_vm.$l10n.__("Ceci est une action définitive."))
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c("CompassButton", {
                    attrs: {
                      label: _vm.$t.__("common.actions.cancel"),
                      type: "secondary"
                    },
                    on: {
                      click: function($event) {
                        _vm.deleteModal = false
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("CompassButton", {
                    attrs: {
                      label: _vm.$t.__("common.actions.delete"),
                      type: "primary-destructive"
                    },
                    on: {
                      click: function($event) {
                        return _vm.deleteReply(_vm.reply)
                      }
                    }
                  })
                ],
                1
              )
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }